import {TXHR} from '../../assets/constants/constansts.type';

export const ORDER_STATUS_CANCELED = 3;

export type TEticketEvent = {
    image?: string;
    imageColors?: string[];
    title: string;
    date?: string;
    timeOpen?: string;
    timeStart?: string;
    timeEnd?: string;
    location?: string;
    address?: string;
};

export type TEticketSeat = {
    section?: string;
    row?: string;
    seat?: string;
};

export type TEticketTicket = {
    title?: string;
    color?: string;
    inviterName?: string;
    oid: number;
    barcode: string;
    tid: number;
    qid: number;
    additionalInfo?: string;
    customFields?: {
        title: string;
        value: string;
    }[];
    seat?: TEticketSeat;
    scanned?: boolean;
    canceled?: boolean;
    scanTs?: number;
};

export type TEticketTransaction = {
    price: string;
    discount?: string;
    couponDiscount?: string;
    itemsCount?: number;
};

export type TEticketProducer = {
    packageName?: string;
    email?: string;
    phone?: string;
    billingId?: string;
    logo?: string;
};

export type TEticketLiveLink = {
    type: string;
    title: string;
    image?: string;
    url: string;
};

export type TEticketLive = {
    logo?: string;
    links: TEticketLiveLink[];
};

export type TEticketOrder = {
    oid: number;
    nameFirst?: string;
    nameLast?: string;
    email?: string;
    phone?: string;
    lang?: string;
    oCurrency?: string;
    ref?: string;
    source?: string;
    payMethod?: string;
    created?: string;
    newsletter?: number;
    status?: number; // ORDER_STATUS_CANCELED (3) = עסקה מבוטלת
};

export type TEticketLinks = {
    eventPage?: string;
    print?: string;
    cancel?: string;
    personalArea?: string;
    receipt?: string;
};

export type TEticketData = {
    lang: string;
    event: TEticketEvent;
    tickets: TEticketTicket[];
    transaction?: TEticketTransaction;
    producer?: TEticketProducer;
    order?: TEticketOrder;
    links?: TEticketLinks;
    live?: TEticketLive;
    walletAllowed?: boolean;
};

export type TEticketScanStatus = {
    scanned: 0 | 1;
    scanTs?: number;
};

export type TEticket = {
    data: TEticketData | null;
    oid: number | null;
    error: string | null;
    getETicketXHR: TXHR;
    getETicketScanStatusXHR: TXHR;
};
